import {
  EMPTY_ERROR,
  GET_INFO_GENERAL_FAILURE,
  GET_INFO_GENERAL_SUCCESS,
  SET_LOADING_INFO,
} from './types';

const initialState = {
  infoGeneral: null, // Cambiar de [] a null para mejor manejo de estado inicial
  isLoadingInfo: false,
  error: null,
};

const infoReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_INFO_GENERAL_SUCCESS:
      return {
        ...state,
        isLoadingInfo: false,
        infoGeneral: action.payload,
        error: null,
      };
    case GET_INFO_GENERAL_FAILURE:
      return {
        ...state,
        isLoadingInfo: false,
        infoGeneral: null, // Cambiar de [] a null
        error: action.payload.response?.data?.error,
      };
    case SET_LOADING_INFO:
      return {
        ...state,
        isLoadingInfo: true,
      };
    case EMPTY_ERROR:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

export default infoReducer;
